/**
 * @module ol/extent/Corner
 */
/**
 * Extent corner.
 * @enum {string}
 */
export default {
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
};
//# sourceMappingURL=Corner.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/extent/Corner.js
// module id = 265
// module chunks = 1